
import AppException from '../AppException'
var FBFansPagePostLinkParser = {
  parse: function (str) {
    var id = str
    if (str.startsWith('https://')) {
      try {
        let url = new URL(str)
        let searchParams = new URLSearchParams(url.search)
        if (url.hostname === 'www.facebook.com') {
          // 電腦版網頁
          if (url.pathname.endsWith('/permalink.php') && searchParams.has('story_fbid')) {
            id = searchParams.get('story_fbid')
            return id
          } else if (url.pathname.endsWith('/plugins/post.php')) {
            if (searchParams.has('story_fbid')) {
              id = searchParams.get('story_fbid')
              return id
            } else if (searchParams.has('href')) {
              let href = searchParams.get('href')
              return this.parse(href)
            }
          } else if (url.pathname.includes('/posts/')) {
            var arr = url.pathname.split('/')
            id = arr[arr.length - 1]
            return id
          }
        }
        // 手機版網址
        if (url.hostname === 'm.facebook.com') {
          if (url.pathname.endsWith('/permalink.php') && searchParams.has('story_fbid')) {
            id = searchParams.get('story_fbid')
            return id
          }
          if (url.pathname.endsWith('/story.php') && searchParams.has('story_fbid')) {
            id = searchParams.get('story_fbid')
            return id
          }
        }
      } catch (e) {}
    } else if (str.startsWith('<iframe')) {
      var node = new DOMParser().parseFromString(str, 'text/html')
      if (node.body.children[0].nodeName.toUpperCase() === 'IFRAME') {
        var src = node.body.children[0].src
        return this.parse(src)
      }
    }

    return id
  },
  testSelf: function () {
    if (FBFansPagePostLinkParser.parse('<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3D1156579067862019%26id%3D500135260173073&width=500" width="500" height="651" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>') !== '1156579067862019') throw new AppException('test embed code failed')
    if (FBFansPagePostLinkParser.parse('https://www.facebook.com/permalink.php?story_fbid=1156579067862019&id=500135260173073&__xts__[0]=68.ARBrfsLIq4VIMTuhoPLN7sXh_2wZfJaMRCl8ysFV6eVCbNMsbdXzJMwn101ecAd-TIioZdHlZStqAlbdSzz07NCfd9egfVYBYkinYBhqJ2At1aOx0_WCQbGnq1C-dapj5bCSfCaPp1P6iFoxaPZb0esf0p1khUwJkDg6Q7QCIx0GI-fC5OOsBUC2JQ4bydDyZBjfqR0mDudPzZ7CDaGb6kyr4W4sLDXF5bOI2Zb0c4uekk7szgZo3x82GGbO503OXYWnmVdlEdlFl6fw-nnuu5KQpniItSwHfeqPB38xCxIuJvjo2nPuclx_O_ofx-5-uDRxzbvi6XawG2okKSVsfEk_pQ&__tn__=-R') !== '1156579067862019') throw new AppException('test www.facebook.com (desktop website link) failed')
    if (FBFansPagePostLinkParser.parse('https://www.facebook.com/permalink.php?story_fbid=1156579067862019&id=500135260173073') !== '1156579067862019') throw new AppException('test permalink failed')
    if (FBFansPagePostLinkParser.parse('https://m.facebook.com/permalink.php?story_fbid=1156579067862019&id=500135260173073&__xts__%5B0%5D=68.ARBsbRheqXTFK9KlcoLhyx6mdQLzSU2mBqlyic4UPg9fov0JIvf80Euhthr5RXAbBIDAEsXEjbgLKMGt3P2h74_Oxhr6HjuHAIX-22BGxAG0CnriIqD1e7X9Y7cYvrrFxA8q-vAvdmxH3ITbZJinhW0-Tw3qgAgFbErMzEVewcU-7BJuU6rNp2edA8Ku3mePJiICUV9zkOOahO_awNr4nITNGLGtRgXPd5pxM_9c0-HYN_IblU118Kex1fmqSdIzFAITk6-niYhVshuJlsJ55Vm99Kn6krWmrSNbYCxmD0qCqBpCKclXpfyuKqdv0JHK1ZmjtROx4yCsTgRVZ86xubIhJQ&__tn__=-R') !== '1156579067862019') throw new AppException('test m.facebook.com (mobile link) failed')
    if (FBFansPagePostLinkParser.parse('https://m.facebook.com/story.php?story_fbid=1926744467606165&id=1534526163494666') !== '1926744467606165') throw new AppException('test m.facebook.com (mobile permalink link) failed')
    if (FBFansPagePostLinkParser.parse('<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2FKingOneDesign%2Fposts%2F734836893612591&width=500" width="500" height="645" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>') !== '734836893612591') throw new AppException('test embed code 2 failed')
    return 'test success'
  }
}
export default FBFansPagePostLinkParser
